/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Motivation_Helper_TextInputs */

const en_register_onboarding_motivation_helper_text = /** @type {(inputs: Register_Onboarding_Motivation_Helper_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why are you applying for this position? Why are you suitable for it?`)
};

const de_register_onboarding_motivation_helper_text = /** @type {(inputs: Register_Onboarding_Motivation_Helper_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum bewirbst du dich auf diese Stelle? Warum bist du dafür geeignet?`)
};

/**
* | output |
* | --- |
* | "Why are you applying for this position? Why are you suitable for it?" |
*
* @param {Register_Onboarding_Motivation_Helper_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_motivation_helper_text = /** @type {((inputs?: Register_Onboarding_Motivation_Helper_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Motivation_Helper_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_motivation_helper_text(inputs)
	return en_register_onboarding_motivation_helper_text(inputs)
});